// Raised totals are loaded from live Stripe. The monthly figure is this centre's running cost.

export const maintenanceTracker = {
  heading: "Donate Today",
  intro: "Markaz Al-Rahma sets aside £2,600 a month for Rahma Centre at 15a Carlisle Road: the rent, the bills, and day-to-day upkeep. Card gifts on this page are added as they clear.",
  goal: 2600,
  quote: "When a person dies, his deeds come to an end except for three: ongoing charity, beneficial knowledge, or a righteous child who prays for him.",
  quoteCitation: "Sahih Muslim",
  appeal: "The £2,600 covers the rent at Rahma Centre, the utilities, and the upkeep.",
  reward: "A gift given here stays with the work at Markaz Al-Rahma.",
  storyTitle: "What the £2,600 is for",
  storyBody: "Rahma Centre on Carlisle Road is used through the week by people from Colindale, Burnt Oak, and Edgware. The monthly figure covers the rent, the bills, and the ordinary upkeep.",
  shareText: "Support the monthly costs of Rahma Centre.",
};
